import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromDrag from './drag.reducer';

export interface DragAndDropState {
  drag: fromDrag.State;
}

export interface State {
  dragAndDrop: DragAndDropState;
}

export const reducers: ActionReducerMap<DragAndDropState> = {
  drag: fromDrag.reducer
};

export const dragAndDropState = createFeatureSelector<DragAndDropState>('drag-and-drop');

/**
 * Drag State
 */
export const dragState = createSelector(
  dragAndDropState,
  (state) => state.drag
);

export const dragZone = createSelector(
  dragState,
  fromDrag.dragZone
);
export const draggedData = createSelector(
  dragState,
  fromDrag.draggedData
);
export const isDragging = createSelector(
  dragState,
  fromDrag.isDragging
);
